import PeopleIcon from '@mui/icons-material/People';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Create, CreateButton, Datagrid, Edit, EditButton, ExportButton, FilterButton, FormTab, ImageField, ImageInput, List, SaveButton, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, Toolbar, TopToolbar, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import ApiKeyInput from 'utils/react-admin/ApiKeyInput';
import AuthPasswordRegenButton from 'utils/react-admin/AuthPasswordRegenButton';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import { Permissions } from '../../ra-php-crud-api-auth';
import SimpleResourceACLInput from 'utils/react-admin/inputs/UserPermission/SimpleResourceACLInput';

export const CHOICES_USER_ROLE = [
  { id: 'system_admin', name: 'system_admin', },
  { id: 'admin', name: 'admin', },
  { id: 'member', name: 'member', },
  { id: 'volunteer', name: 'volunteer', },
];

const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <TextInput source="username" fullWidth />,
  <TextInput source="customer_name" fullWidth />,
  <TextInput source="contact_name" fullWidth />,
  <TextInput source="api_key" fullWidth />,
  <TextInput source="email" fullWidth />,
  <TextInput source="telephone" fullWidth />,
  <TextInput source="mobile" fullWidth />,
  <TextInput source="address_1" fullWidth />,
  <TextInput source="address_2" fullWidth />,
  <TextField source="firebase_uid" fullWidth />,
  <TextField source="firebase_email" fullWidth />,
  <TextField source="firebase_phone" fullWidth />,
  <SelectInput source="role" alwaysOn fullWidth choices={CHOICES_USER_ROLE} />,
  <DateRangeFilterInput source="release" fullWidth />,
  <DateRangeFilterInput source="expiry" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateUsername: any[] = [];
const validateApiKey: any[] = [];
const validateEmail: any[] = [];
const validateTelephone: any[] = [];
const validateMobile: any[] = [];
const validateAddress1: any[] = [];
const validateAddress2: any[] = [];
// const validateFirebaseUid: any[] = [];
// const validateFirebaseEmail: any[] = [];
// const validateFirebasePhone: any[] = [];
const validateRole: any[] = [required()];
// const validateRelease: any[] = [required()];
// const validateExpiry: any[] = [];
// const validateImageFile: any[] = [];

const ReourceListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportButton />
    </TopToolbar>
  );
};

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  // const translate = useTranslate();
  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} actions={<ReourceListActions />} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.username} (#${record.id})`}
          secondaryText={(record: any) => `${record.email}`}
          tertiaryText={(record: any) => `${record.mobile}`}
        ></SimpleList>)
        : (
          <Datagrid>
            {/* <TextField source="id" /> */}
            <TextField source="username" fullWidth />
            <TextField source="customer_name" fullWidth />
            <TextField source="contact_name" fullWidth />
            {/* <TextField source="api_key" fullWidth /> */}
            <TextField source="email" fullWidth />
            {/* <TextField source="telephone" fullWidth /> */}
            <TextField source="mobile" fullWidth />
            {/* <TextField source="address_1" fullWidth /> */}
            {/* <TextField source="address_2" fullWidth /> */}
            {/* <TextField source="firebase_uid" fullWidth /> */}
            {/* <TextField source="firebase_email" fullWidth /> */}
            {/* <TextField source="firebase_phone" fullWidth /> */}
            <TextField source="role" fullWidth />
            {/* <ReferenceManyField label="vehicle" reference="vehicle" target="user_id"> */}
            {/* <SingleFieldList><ChipField source="licence_no" /></SingleFieldList> */}
            {/* </ReferenceManyField> */}
            {/* <DateFnsField showTime={true} source="release" fullWidth />
            <DateFnsField showTime={true} source="expiry" fullWidth /> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();
  // const translate = useTranslate();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="username" fullWidth />
        {/* <TextField source="api_key" fullWidth /> */}
        <TextField source="customer_name" fullWidth />
        <TextField source="contact_name" fullWidth />
        <TextField source="email" fullWidth />
        <TextField source="telephone" fullWidth />
        <TextField source="mobile" fullWidth />
        <TextField source="address_1" fullWidth />
        <TextField source="address_2" fullWidth />
        {/* <TextField source="firebase_uid" fullWidth /> */}
        <TextField source="firebase_email" fullWidth />
        <TextField source="firebase_phone" fullWidth />
        <TextField source="role" fullWidth />
        {/* <DateFnsField showTime={true} source="release" fullWidth />
        <DateFnsField showTime={true} source="expiry" fullWidth /> */}
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  data.simple_acl = ('string' === typeof data.simple_acl) ? data.simple_acl : (null === data.simple_acl ? null : JSON.stringify(data.simple_acl));
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};
  // const record = useRecordContext();

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }} toolbar={<MyToolbar />}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><SelectInput source="role" fullWidth choices={CHOICES_USER_ROLE} validate={validateRole} /></Grid>
          <Grid item xs={6}><TextInput source="username" fullWidth validate={validateUsername} /></Grid>
          <Grid item xs={6}><ApiKeyInput source="api_key" fullWidth validate={validateApiKey} /></Grid>
          <Grid item xs={6}><AuthPasswordRegenButton /></Grid>
          <Grid item xs={6}><TextInput source="email" fullWidth validate={validateEmail} /></Grid>
          <Grid item xs={6}><TextInput source="customer_name" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="contact_name" fullWidth /></Grid>
          <Grid item xs={3}><TextInput source="telephone" fullWidth validate={validateTelephone} /></Grid>
          <Grid item xs={3}><TextInput source="mobile" fullWidth validate={validateMobile} /></Grid>
          <Grid item xs={6}><TextInput source="address_1" fullWidth validate={validateAddress1} /></Grid>
          <Grid item xs={6}><TextInput source="address_2" fullWidth validate={validateAddress2} /></Grid>
        </GridWrapper>
        {/* <TextField source="firebase_uid" fullWidth />
          <TextField source="firebase_email" fullWidth />
          <TextField source="firebase_phone" fullWidth /> */}
        {/* <DateTimeInput source="release" fullWidth validate={validateRelease} />
          <DateTimeInput source="expiry" fullWidth validate={validateExpiry} /> */}
        <ImageInput source="image_file" fullWidth accept="image/*"><ImageField sx={{ '& img': { maxWidth: 200, maxHeight: 200, objectFit: 'contain' } }} source="url" title="title" /></ImageInput>
      </FormTab>
      <FormTab label="ra.page.simple_acl">
        <GridWrapper>
          <Grid item xs={12}><SimpleResourceACLInput source="simple_acl" fullWidth /></Grid>
        </GridWrapper>
      </FormTab>
    </TabbedForm>
  )
}

const MyToolbar = () => (
  <Toolbar>
    <SaveButton alwaysEnable />
  </Toolbar>
);

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: PeopleIcon,
}

export default Resource;
